import React from 'react';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { homeCopy } from '@/contexts/language/translations/pages/home';

const ValuesSection = () => {
  const { language } = useLanguage();
  const c = homeCopy[language].values;
  const VALUES = c.items;

  return (
    <section className="py-20 bg-[#FAFAFA]">
      <div className="container-custom max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-4 py-2 rounded-lg bg-foreground text-white text-xs font-semibold mb-6">
            {c.badge}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            {c.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {VALUES.map((value) => (
            <div key={value.title} className="rounded-2xl border border-gray-100 bg-white p-7 shadow-sm">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF6B35] mb-4 block">
                {value.title}
              </span>
              <p className="text-muted-foreground">{value.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
